import { render, staticRenderFns } from "./MatriculasAnosFinaisCard.vue?vue&type=template&id=874b3c6a&scoped=true"
import script from "./MatriculasAnosFinaisCard.vue?vue&type=script&lang=js"
export * from "./MatriculasAnosFinaisCard.vue?vue&type=script&lang=js"
import style0 from "./MatriculasAnosFinaisCard.vue?vue&type=style&index=0&id=874b3c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874b3c6a",
  null
  
)

export default component.exports